import pdfMake from 'pdfmake/build/pdfmake.min.js';
import pdfFonts from './PdfMake/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const FONT_NAME = 'StackSansText';
pdfMake.fonts = {
    StackSansText: {
        normal: 'StackSansText-Regular.ttf',
        bold: 'StackSansText-Regular.ttf',
        italics: 'StackSansText-Regular.ttf',
        bolditalics: 'StackSansText-Regular.ttf',
    },
};

const logo =
    'data:image/png;base64,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';

pdfMake.tableLayouts = {
    sellsy: {
        hLineWidth: function (i, node) {
            return 0;
        },
        vLineWidth: function (i) {
            return i === 1 ? 1 : 0;
        },
        vLineColor: '#CCCCD1',
        paddingLeft: function (i) {
            return 40;
        },
        paddingRight: function (i, node) {
            return 40;
        },
        fillColor: '#F6F6F9',
    },
};

const createPdf = (backupCodes, pdfText, download = false) => {
    const backupCodeNodes = backupCodes.map((item, index) => {
        return {
            text: item.code,
            style: item.used_at !== null ? 'used' : '',
            index,
        };
    });

    const generationDate = moment(backupCodes[0].createdAt).format('LL');

    const leftNodes = backupCodeNodes.slice(0, 5);
    const rightNodes = backupCodeNodes.slice(5, 10);
    const organizedCodes = leftNodes.map((node, key) => {
        return [node, rightNodes[key]];
    });

    // insert blank lines into table
    organizedCodes.unshift([
        { text: ' ', borderColor: ['#F6F6F9', '#F6F6F9', '#F6F6F9', '#F6F6F9'] },
        { text: ' ', borderColor: ['#F6F6F9', '#F6F6F9', '#F6F6F9', '#F6F6F9'] },
    ]);
    organizedCodes.push([
        { text: ' ', borderColor: ['#F6F6F9', '#F6F6F9', '#F6F6F9', '#F6F6F9'] },
        { text: ' ', borderColor: ['#F6F6F9', '#F6F6F9', '#F6F6F9', '#F6F6F9'] },
    ]);

    const docDefinition = {
        content: [
            {
                image: logo,
                width: 160,
                style: 'logo',
            },
            {
                text: pdfText.header,
                style: 'header',
            },
            {
                text: pdfText.attention,
                style: 'text',
            },
            {
                style: 'table',
                table: {
                    headerRows: 0,
                    widths: ['auto', 'auto'],
                    body: organizedCodes,
                },
                layout: 'sellsy',
            },
            {
                text: `${pdfText.generationDate} ${generationDate}`,
                style: 'text',
            },
            {
                text: pdfText.singleUse,
                style: 'text',
            },
        ],
        defaultStyle: {
            font: FONT_NAME,
        },
        styles: {
            logo: {
                margin: [0, 0, 0, 16],
            },
            header: {
                fontSize: 20,
                bold: true,
                margin: [0, 0, 0, 16],
            },
            used: {
                decoration: 'lineThrough',
                color: '#8C909C',
            },
            table: {
                margin: [0, 0, 0, 16],
                fontSize: 17,
            },
            text: {
                margin: [0, 0, 0, 16],
            },
        },
    };

    download
        ? pdfMake.createPdf(docDefinition).download('backupCodes.pdf')
        : pdfMake.createPdf(docDefinition).print();
};

export default createPdf;
